export const mapEmptyStringToUndefined = (value?: string): string | undefined => {
    if (value === "") {
        return undefined;
    }

    return value;
};
